import { render, staticRenderFns } from "./AssignPlayerMatch.vue?vue&type=template&id=5ba66506&scoped=true"
import script from "./AssignPlayerMatch.vue?vue&type=script&lang=js"
export * from "./AssignPlayerMatch.vue?vue&type=script&lang=js"
import style0 from "./AssignPlayerMatch.vue?vue&type=style&index=0&id=5ba66506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba66506",
  null
  
)

export default component.exports